export default __webpack_public_path__ + "static/media/LAS0710.34I-35931_-20960_0.abd566ba.jpg";